class ProductShipping extends HTMLElement {
    constructor() {
        super();
        this.shippingRow = document.querySelector(".freebies-success-shipping");
        this.shippingValue = this.shippingRow
            ? this.shippingRow.querySelector("[data-shipping-value]")
            : null;
    }

    connectedCallback() {
        this.compute();
        this.listenCart();
    }

    listenCart() {
        const cartDrawer = document.querySelector("cart-drawer");
        if (cartDrawer && cartDrawer.dataStore) {
            // Recompute after the cart (and its line items) re-render.
            cartDrawer.dataStore.listen("prices", () => this.compute());
            cartDrawer.dataStore.listen("sectiondom", () => this.compute());
        }
    }

    // Cart total in major units (dollars), matching the threshold setting.
    getCartTotal() {
        const meter = document.querySelector("freebies-meter");
        if (meter && meter.dataset.cartTotal) return parseFloat(meter.dataset.cartTotal);
        const cartDrawer = document.querySelector("cart-drawer");
        try {
            const prices = cartDrawer.dataStore.getCurrData().prices;
            if (prices && prices.total_price != null) return prices.total_price / 100;
        } catch (e) {
            /* no cart data available */
        }
        return null;
    }

    // Sum of distinct per-product rates found on the line items.
    distinctSum() {
        const cards = document.querySelectorAll("line-item-card[data-shipping-rate]");
        const seen = new Set();
        let sum = 0;
        cards.forEach((card) => {
            const raw = card.dataset.shippingRate;
            if (raw === "" || raw == null) return;
            const rate = parseFloat(raw);
            if (isNaN(rate)) return;
            const key = rate.toFixed(2);
            if (seen.has(key)) return;
            seen.add(key);
            sum += rate;
        });
        return { sum, count: seen.size };
    }

    formatPrice(amountMajor) {
        const cents = Math.round(amountMajor * 100);
        let formatted = window.currencyAPIObj
            ? window.currencyAPIObj.formatMoney(cents)
            : "$" + (cents / 100).toFixed(2);
        // Append the currency code to match the fixed price's money_with_currency
        const currencyEl = document.querySelector("[data-currency]");
        const currency = currencyEl ? currencyEl.dataset.currency : "";
        if (currency) formatted += " " + currency;
        return formatted;
    }

    compute() {
        if (!this.shippingRow || !this.shippingValue) return;

        const threshold = parseFloat(this.shippingRow.dataset.shippingThreshold) || 0;
        const cartTotal = this.getCartTotal();
        const { sum, count } = this.distinctSum();

        let text;
        if (threshold && cartTotal != null && cartTotal >= threshold) {
            // Free-shipping threshold reached — always wins.
            text = "Free";
            delete this.shippingRow.dataset.computedShipping;
        } else if (count === 0) {
            // No per-product rates set — fall back to the configured fixed price.
            text = this.shippingRow.dataset.shippingPriceFormatted || "Free";
            delete this.shippingRow.dataset.computedShipping;
        } else if (sum === 0) {
            text = "Free";
            this.shippingRow.dataset.computedShipping = text;
        } else {
            text = this.formatPrice(sum);
            this.shippingRow.dataset.computedShipping = text;
        }

        this.shippingValue.textContent = text;
    }
}

customElements.define("product-shipping", ProductShipping);
